import * as React from "react";
import { MyAccountService } from "./myaccount-service";
import { TransactionHistory, AutoProfile, SiteSettings } from "../types";
import TrxBlock from "../common/TrxBlock";
import AutoProfileBlock from "./AutoProfileBlock";
import { Link } from "react-router-dom";
import { Props } from "../../types/global";
import SupportTicketBlock from "./SupportTicketBlock";
import ContactBlock from "./ContactBlock";
import { Loading } from "../common/Loading";
import { LinkButton } from "../Controls/LinkButton";
import t from "../i18n";
import { TopupService } from "../services/topup-service";
import { HomeFooter } from "./HomeFooter";
import { ProductCategory } from "../types-enums";
import { CatalogService } from "src/services/catalog-service";

declare type HomeState = {
    transactions: TransactionHistory[],
    hasMoreTrx: boolean,
    profiles: AutoProfile[],
    hasMoreProfiles: boolean,
    contacts: any[],
    tickets: any[],
    contactsLoaded: boolean,
    ticketsLoaded: boolean,
    trxLoaded: boolean,
    rewardPointBalance: number,
    siteSettings: SiteSettings,
    storedCardsCount: number
}
export default class Home extends React.Component<Props> {
    readonly state: HomeState = {
        transactions: [],
        hasMoreTrx: false,
        profiles: [],
        hasMoreProfiles: false,
        contacts: [],
        tickets: [],
        ticketsLoaded: false,
        contactsLoaded: false,
        trxLoaded: false,
        rewardPointBalance: 0,
        siteSettings: {} as SiteSettings,
        storedCardsCount: 0
    };
    async componentDidMount() {
        const response = await MyAccountService.fetchRecentTransactionsAndRecurringProfiles();
        if (!response) {
            this.props.history.push("/topup");
            return;
        }
        if (response.responseCode === 0 && response.payLoad) {
            this.setState({
                transactions: response.payLoad.transactions,
                profiles: response.payLoad.profiles,
                trxLoaded: true,
                hasMoreTrx: response.payLoad.hasMoreTrx,
                hasMoreProfiles: response.payLoad.hasMoreProfiles,
                rewardPointBalance: response.payLoad.rewardPointBalance,
                storedCardsCount: response.payLoad.storedCardsCount
            });
        }
        this.loadPhoneBook();
        this.loadSupportTickets();
        this.loadSiteSettings();        
    }
    loadSiteSettings = async () => {
        const siteSettingsResponse = await TopupService.fetchSiteSettings();
        this.setState({siteSettings: siteSettingsResponse.payLoad});
    }
    loadPhoneBook = () => {
        MyAccountService.fetchPhoneBook().then(response => {
            this.setState({ contacts: response.payLoad || [], contactsLoaded: true })
        });
    }
    loadSupportTickets = () => {
        MyAccountService.fetchTickets().then(response => {
            this.setState({ tickets: response.payLoad || [], ticketsLoaded: true })
        });
    }
    onRepeat = (sessionId: string, category: ProductCategory) => {
        if(category === ProductCategory.GiftCard)
        {
            this.props.history.push(`/giftcard?sid=${sessionId}&step=summary`);
        }
        else
        {
            this.props.history.push(`/topup?sid=${sessionId}&step=summary`);
        }
    }
    topupByContact = (entry: any) => {
        this.props.history.push(`/topup?cc=${entry.countryCode}&m=${entry.mobileNumber}&p=${entry.productId}&step=order`);
    }
    renderTrx() {
        const trx = this.state.transactions;
        return <React.Fragment>
            <div className="form-group">
                <div className="row">
                    <div className="col-6 font-weight-600">{t.menu("order_history")}</div>
                    <div className="col-6 text-right font-italic font-weight-500">
                        <LinkButton className="view-active"  to="/order-history" disabled={!this.state.hasMoreTrx}>{t.topup("view_all_link")}</LinkButton>
                    </div>
                </div>
            </div>
            {trx.length === 0 && <div className="form-group no-record-exists">{t.myaccount("no_topup")}</div>}
            {trx.length > 0 && <div className="row">
                {trx.map(trx2 => <TrxBlock key={trx2.transactionId} trx={trx2} onRepeat={this.onRepeat} />)}
            </div>}
        </React.Fragment>
    }
    renderAutoTopups() {
        const profiles = this.state.profiles;
        return <React.Fragment>
            <div className="form-group">
                <div className="row">
                    <div className="col-6 font-weight-600">{t.autoTopup("auto_balance_header")}</div>
                    <div className="col-6 text-right font-italic font-weight-500">
                    {!CatalogService.isSitePosIT() && !CatalogService.isSiteCodesDirect() && <LinkButton className="view-active" to="/auto-topups" disabled={!this.state.hasMoreProfiles}>{t.topup("view_all_link")}</LinkButton>}
                    </div>
                </div>
            </div>
            {profiles.length === 0 && <div className="form-group no-record-exists">{t.myaccount("no_auto_topup")}</div>}
            {profiles.length > 0 && <div className="row">
                {profiles.map(ap => <AutoProfileBlock key={ap.recurringProfileId} profile={ap} />)}
            </div>}
        </React.Fragment>
    }
    renderPhoneBook() {
        if (!this.state.contactsLoaded) return null;
        const contacts = this.state.contacts;
        return <React.Fragment>
            <div className="form-group">
                <div className="row">
                    <div className="col-6 font-weight-600">{t.menu("contact_list")}</div>
                    <div className="col-6 text-right font-italic font-weight-500">
                        <Link className="create-new-link" to="/contact/new" style={{marginRight: 5}}>{t.myaccount("new_contact")}</Link>
                        <LinkButton className="view-active" to="/contact-list" disabled={contacts.length <= 2}>{t.topup("view_all_link")}</LinkButton>
                    </div>
                </div>
            </div>
            <div>
                <div className="row">
                    {contacts.filter((c, index) => index < 2).map(entry =>
                        <ContactBlock key={entry.phonebookId}
                        entry={entry}
                        onTopupByContact={this.topupByContact}
                        onDeleted={this.loadPhoneBook}
                        />
                    )}
                </div>
            </div>
        </React.Fragment>
    }
    renderTickets() {
        if (!this.state.ticketsLoaded) return null;
        const tickets = this.state.tickets;
        return <React.Fragment>
            <div className="form-group">
                <div className="row">
                    <div className="col-5 font-weight-600">{t.menu("support_tickets")}</div>
                    <div className="col-7 text-right font-italic font-weight-500">
                        <Link className="create-new-link" to="/ticket/new" style={{marginRight: 5}}>{t.myaccount("new_ticket")}</Link>
                        <LinkButton className="view-active" to="/tickets" disabled={tickets.length <= 2}>{t.topup("view_all_link")}</LinkButton>
                    </div>
                </div>
            </div>
            {tickets.length === 0 && <div className="no-record-exists">{t.myaccount("no_ticket")}</div>}
            {tickets.length > 0 && <div>
                {tickets.filter((ticket, index) => index < 2).map(ticket =>
                    <SupportTicketBlock key={ticket.id} ticket={ticket} />
                )}
            </div>}
        </React.Fragment>
    }
    renderRewardPoints() {
        //show reward points only on ETO site 
        if(!CatalogService.isSiteETO()) return null;
        if (this.state.rewardPointBalance === 0) return null;
        if (this.state.siteSettings.allowRewardPoints === false) return null;
        return <React.Fragment>
            <div className="form-group">
                <div className="row">
                    <div className="col-6 font-weight-600">{t.menu("reward_points")}</div>
                    <div className="col-6 text-right font-italic font-weight-500">
                        <Link className="view-active" to="/reward-points">{t.myaccount("review-history")}</Link>
                    </div>
                </div>
            </div>
            <div className="form-group">
                {t.myaccount("reward-point-balance-msg", {rewardPointBalance: this.state.rewardPointBalance})}
            </div>
        </React.Fragment>
    }
    renderStoredCards(){
        if(this.state.storedCardsCount == 0) return null;
        return <React.Fragment>
            <div className="form-group" style={{marginBottom: "80px"}}>
                <div className="row">
                    <div className="col-6 font-weight-600">{t.menu("stored-cards")}</div>
                    <div className="col-6 text-right font-italic font-weight-500">
                        <LinkButton className="view-active" to="/stored-cards">{t.topup("view_all_link")}</LinkButton>
                    </div>
                </div>
            </div>
        </React.Fragment>
    }

    render() {
        if (!this.state.trxLoaded) return <Loading />;
        return (
            <div className="container small-gutter" style={pageWidth}>
                <div className="form-group form-title">
                    <h2>{t.menu("dashboard")}</h2>
                </div>
                {this.renderTrx()}
                {this.renderAutoTopups()}
                {this.renderPhoneBook()}
                {this.renderTickets()}
                {this.renderRewardPoints()}
                {this.renderStoredCards()}
                <HomeFooter  />
            </div>
        );
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}
